import { useState } from "react";
import { Lock } from "lucide-react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, ApiError } from "../../lib/api";
import { toast } from "../../stores/toast";
import { Button, Input } from "../../components/ui";

export function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!token) {
      toast("error", "Invalid reset link");
      return;
    }
    if (password.length < 8) {
      toast("error", "Password must be at least 8 characters");
      return;
    }
    setBusy(true);
    try {
      await api("/auth/reset-password", { body: { token, password } });
      toast("success", "Password reset — sign in with your new password");
      navigate("/login", { replace: true });
    } catch (err) {
      toast("error", err instanceof ApiError ? err.message : "Reset failed — the link may have expired");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-[70vh] flex-col justify-center px-6">
      <div className="mx-auto w-full max-w-sm space-y-6 text-center">
        <div>
          <Lock size={48} strokeWidth={1.25} className="mx-auto text-white/40" />
          <h1 className="mt-3 font-display text-xl font-bold">Choose a new password</h1>
        </div>
        <form className="space-y-3" onSubmit={submit}>
          <Input
            type="password"
            placeholder="New password (min 8 characters)"
            autoComplete="new-password"
            required
            minLength={8}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button type="submit" className="w-full" disabled={busy}>
            {busy ? "Resetting…" : "Reset password"}
          </Button>
          <Link to="/login" className="block text-xs text-white/50">
            Back to sign in
          </Link>
        </form>
      </div>
    </div>
  );
}
